import * as yup from "yup";

export const materialPlaningListSchemaNew = yup.object().shape({
  project: yup.string().required("Client project is required"),
  length: yup.string().required("length is required"),
  width: yup.string().required("width is required"),
  hydroponicType: yup.string().required("hydroponic type is required"),
  a_FramePercent: "",
  flatBedPercent: "",
  growBagPercent: "",
  growBagPercent: "",
  dutchBucketPercent: "",
  vehicalNum: "",
});
